module.exports = __webpack_public_path__ + "img/scene-greenhouse.aaa2a276.jpg";